import React from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import styles from "./AuthLayout.module.scss";

const AuthBrandPanel = () => {
  const location = useLocation();

  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const loginValue = useMemo(
    () => searchParams.get("type") ?? "1",
    [searchParams]
  );

  const [t] = useTranslation();
  return (
    <div className={`${styles["left-panel"]} left-panel`}>
      <div className="intro">
        <h2>{t("authenticationLeftPanel.welcomeToTitle")}</h2>
        <p>{t("authenticationLeftPanel.welcomeToDescription")}</p>
        {loginValue === "1" && (
          <img
            src="/assets/images/Scandi-automation-gif.png"
            alt=""
            className="img-fluid"
          />
        )}
        {loginValue === "2" && (
          <img
            src="/assets/images/Scandi-automation-gif.png"
            alt=""
            className="img-fluid left-head"
          />
        )}
        {loginValue === "3" && (
          <img
            src="/assets/images/Scandi-automation-gif.png"
            alt=""
            className="img-fluid left-head-3"
          />
        )}
        {loginValue === "4" && (
          <img
            src="/assets/images/head_trimmed.png"
            alt=""
            className="img-fluid left-head-4"
          />
        )}
      </div>
    </div>
  );
};

export default AuthBrandPanel;
